/**
 * Chip marking a note section whose relevance depends on the patient's age
 * ("adult" / "pediatric", D10). Rendered next to the section header on both the
 * call guide and the Notes step so the two surfaces label age gating
 * identically — the pediatric and adult Social History sections share a label
 * and are told apart only by this chip.
 * @agentic connections
 */

import { Badge } from "@mantine/core";

import type { NoteSection } from "./note-sections";

/**
 * Props for the note-section audience badge.
 * @agentic connections
 */
export type NoteSectionAudienceBadgeProps = {
  audience: NonNullable<NoteSection["audience"]>;
};

/**
 * Small age-audience chip for a note section header.
 * @agentic connections
 */
export const NoteSectionAudienceBadge = ({
  audience,
}: NoteSectionAudienceBadgeProps) => (
  <Badge
    size="xs"
    radius="sm"
    variant="light"
    color={audience === "pediatric" ? "grape" : "blue"}
  >
    {audience}
  </Badge>
);
